import { gql } from '@apollo/client';

const UPDATE_CUSTOM_TEACHING_ORDER = gql`
  mutation ($data: CustomTeachingOrderUpdateInput!) {
    updateCustomTeachingOrder(data: $data) {
      id
      name
      characters {
        id
        character
      }
    }
  }
`;

export default UPDATE_CUSTOM_TEACHING_ORDER;
